import {API_ENDPOINTS} from '../constants';
import {getAuthToken} from './account';

// Pushing changes to trigger build

export async function deleteMessage(id: string): Promise<{success: boolean}> {
    const req = await fetch(API_ENDPOINTS.deleteMessage(id), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
        },
    });
    return {
        success: req.ok,
    };
}

export async function sendMessage(
    to: string[],
    from: string,
    database: string,
    replyTo: string,
    subject: string,
    body: string
): Promise<{success: boolean}> {
    const req = await fetch(API_ENDPOINTS.sendMessage(), {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            to,
            from,
            database,
            replyTo,
            subject,
            body,
        }),
    });
    return {
        success: req.ok,
    };
}

export interface IInboxItem {
    database: string;
    from: string;
    name: string;
    read?: string;
    replyTo: string;
    sent: number;
    subject: string;
    to: string;
}

export async function getPersonalMessages(): Promise<{success: boolean; messages?: IInboxItem[]}> {
    const req = await fetch(API_ENDPOINTS.personalInbox(), {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });
    const messages = await req.json();
    return {
        success: true,
        messages,
    };
}

export async function getOrganizationMessages(): Promise<{
    success: boolean;
    inbox?: IInboxItem[];
    outbox?: IInboxItem[];
}> {
    const inboxRequest = await fetch(API_ENDPOINTS.organizationInbox(), {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });
    const outboxRequest = await fetch(API_ENDPOINTS.organizationOutbox(), {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });
    const inbox = await inboxRequest.json();
    const outbox = await outboxRequest.json();
    return {
        success: true,
        inbox,
        outbox,
    };
}

export async function getMessageThread(messageId: string): Promise<{
    success: boolean;
    messages?: IMessage[];
}> {
    const req = await fetch(API_ENDPOINTS.getMessageThread(messageId), {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });
    const messages = await req.json();
    return {
        success: true,
        messages,
    };
}

export interface IMessage {
    body: string;
    database?: string;
    from: string;
    name: string;
    read?: number;
    replyTo?: string;
    sent: number;
    subject: string;
    to: string;
}

export async function readMessage(id: string): Promise<{success: boolean; message?: IMessage}> {
    try {
        const req = await fetch(API_ENDPOINTS.readMessage(id), {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
        });
        const message = await req.json();
        return {
            success: true,
            message,
        };
    } catch (exception) {
        return {
            success: false,
        };
    }
}

export async function getAccountsForDatabase(
    name: string
): Promise<{success: boolean; accounts?: Array<{name: string; address: string}> | undefined}> {
    try {
        const req = await fetch(API_ENDPOINTS.getAccountsForDatabase(name), {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
        });
        const accounts = await req.json();
        return {
            success: true,
            accounts,
        };
    } catch (exception) {
        return {
            success: false,
        };
    }
}



// WEBPACK FOOTER //
// ./src/services/messages.ts